
import React, { Fragment, PureComponent } from 'react';
import { Button, Card, Col, Form, Input, Modal, Row, Breadcrumb } from 'antd';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { CALCULATE_BALANCE_YESBANK, NETWORKCARD_CONSTANTS } from '../NetworkCards/constants';
import { StyledYesBankZingerCard, ZaggleCard } from '../NetworkCards/StyledNetworkCard';
import { YesBankRenewalManagementDispatchToProps, YesBankRenewalManagementPropTypes, YesBankRenewalManagementStateToProps } from './yesBankRenewalManagementDataHandler';
import { AppWrappperHOC } from '../Root/HOC';
import { Container } from '../../components';
import { constants, utils, validationRules } from '../../devUtils';
import { OtpScreen } from '../NetworkCards/OtpScreen';

const { YES_BANK_CARD_REPLACEMENT } = NETWORKCARD_CONSTANTS;
const { TextArea } = Input;
const { Item } = Breadcrumb;

class YesBankRenewalManagement extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      modalType: '',
      OTP: '',
      showResendText: false,
      remainingTime: 60,
    };
    this.startTimer = this.startTimer.bind(this);
    this.verifyYesBankOtp = this.verifyYesBankOtp.bind(this);
    this.handleOTPChange = this.handleOTPChange.bind(this);
    this.handleResendYblOtp = this.handleResendYblOtp.bind(this);
    this.handleModal = this.handleModal.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentDidMount() {
    const {
      match: {
        params: {
          id: card_id = '',
        } = {},
      },
      history: {
        location = {},
      } = {},
      onFetchCardData,
    } = this.props;
    onFetchCardData(card_id, location);
  }

  componentWillReceiveProps(nextProps) {
    const {
      GetYesBankOtpSuccess, GetYesBankOtpSuccess: { status: yesBankOtpSuccessStatus = false },
      onSetChannelFlagSuccess,
      SetChannelFlagSuccess, SetChannelFlagSuccess: { status: channelFlagSuccessStatus },
      onFetchCardData,
      history,
      match: { params: { id: card_id = '' } = {} } = {},
      history: {
        location = {},
      } = {},
    } = nextProps;
    const {
      GetYesBankOtpSuccess: _GetYesBankOtpSuccess,
      SetChannelFlagSuccess: _SetChannelFlagSuccess,
    } = this.props;
    if (!utils.isEqual(GetYesBankOtpSuccess, _GetYesBankOtpSuccess) && yesBankOtpSuccessStatus) {
      this.setState({ modalType: 'YESBANK_OTP_SCREEN' });
      this.startTimer();
    }
    if (!utils.isEqual(SetChannelFlagSuccess, _SetChannelFlagSuccess) && channelFlagSuccessStatus) {
      this.setState({ OTP: '', showResendText: false, remainingTime: 60 });
      onSetChannelFlagSuccess();
      this.setState({ modalType: '' });
      onFetchCardData(card_id, location);
      clearInterval(this.timer);
      utils.forceRedirect(history, { pathname: constants.LINK_PAY_BALANCE });
    }
  }

  sendOtp(type) {
    const {
      onGetOtp,
    } = this.props;
    onGetOtp({ otp_type: type });
  }

  handleOTPChange(OTP) {
    this.setState({ OTP });
  }

  handleResendYblOtp(type) {
    const {
      onGetOtp,
    } = this.props;
    clearInterval(this.timer);
    onGetOtp({ otp_type: type });
    this.setState({
      showResendText: false,
      remainingTime: 60,
    });
  }

  handleSubmit(e) {
    e.preventDefault();
    this.props.form.validateFields((err) => {
      if (!err) {
        this.sendOtp(YES_BANK_CARD_REPLACEMENT);
      }
    });
  }

  handleModal(type) {
    this.setState({
      modalType: typeof (type) === 'string' ? type : '',
    });
  }

  startTimer() {
    this.timer = setInterval(() => {
      const { remainingTime } = this.state;
      if (remainingTime === 1) {
        clearInterval(this.timer);
        this.setState({ showResendText: true });
      }
      this.setState((prevState) => ({
        remainingTime: prevState.remainingTime - 1,
      }));
    }, 1000);
  }


  verifyYesBankOtp(type) {
    const {
      CardDataYbl,
      onSetChannelFlag,
      form: {
        getFieldValue,
      } = {},
    } = this.props;
    const {
      cards: [
        {
          kit_number = '',
          card_type = '',
        } = {},
      ] = [],
    } = CardDataYbl;
    const {
      OTP,
    } = this.state;
    const action_type = 'renewal';
    const dispatchAddress = getFieldValue('dispatch_address');
    if (type === YES_BANK_CARD_REPLACEMENT) {
      onSetChannelFlag({
        kit_number,
        action_type,
        dispatch_address: dispatchAddress,
        otp: OTP,
      }, { cardType: card_type, type: 'ACTIONS' });
    }
  }

  renderModalCloseFunction(modalType) {
    switch (modalType) {
      case 'YESBANK_OTP_SCREEN':
        return this.handleModal;
      default:
        return () => '';
    }
  }

  renderCardImages(CardDataYbl) {
    let showImage = null;
    const {
      match: { params: { id } },
      CardDataYbl: {
        cards: [
          {
            expiry_month = '',
            expiry_year = '',
            card_status = '',
            code = '',
            name = '',
            cvv = '',
          } = {},
        ] = [],
      } = {},
    } = this.props;

    if (cvv) {
      showImage = (
        <Fragment>
          <input type="checkbox" id="CardClick" />
          <label className="card-containert" htmlFor="CardClick">
            <div className="card-flip">
              <div className={`side ${!['physical', 'virtual'].includes(id) ? '' : ''}`}>
                <h1 className="balance">
                  Rs. {CALCULATE_BALANCE_YESBANK(CardDataYbl)}
                </h1>
                <h3 className="card-name">
                  {name}
                </h3>
                <div className="footer">
                  <span className="font-14 pb-05">Card Number:</span> {code}<br />
                  <span className="font-14 pb-05">Expiry:</span> {expiry_month}/{expiry_year}<br />
                  <span className="font-14 pb-05">Card Status:</span> {card_status}<br />
                </div>
              </div>
              <div className="side back">
                <div className="card-details">
                  <span className="card-expiry">{expiry_month}/{expiry_year}</span>
                  <span className="card-cvv">{cvv}</span>
                </div>
              </div>
            </div>
          </label>
        </Fragment>
      );
    } else {
      showImage = (
        <div className="card-flip default">
          <div className={`side ${!['physical', 'virtual'].includes(id) ? 'default-user' : ''}`}>
            <h1 className="balance">Rs. {CALCULATE_BALANCE_YESBANK(CardDataYbl)}</h1>
            <h3 className="card-name">{name}</h3>
            <div className="footer">
              <Row align="middle" type="flex" gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <span className="font-12 pb-05">Card Number:</span> {code}<br />
                  {expiry_month ? <Fragment><span className="font-12 pb-05">Expiry:</span> {expiry_month}/{expiry_year}<br /></Fragment> : null}
                  <span className="font-12 pb-05">Card Status:</span> {card_status}<br />
                </Col>
              </Row>
            </div>
          </div>
        </div>
      );
    }
    return (
      <Col xs={24} sm={24} md={10} lg={10} xl={10}>
        <StyledYesBankZingerCard>
          {showImage}
        </StyledYesBankZingerCard>
      </Col>
    );
  }

  renderAddressForm() {
    const {
      form: {
        getFieldDecorator,
      } = {},
    } = this.props;

    return (
      <Form onSubmit={this.handleSubmit}>
        <Fragment>
          <h3> Address For Dispatch *</h3>
          <Form.Item className="margin-b-1">
            {getFieldDecorator('dispatch_address', {
              rules: [validationRules.mandatory],
            })(
              <TextArea rows={4} placeholder="Enter Your Address" />
            )}
          </Form.Item>
          <Row align="middle" type="flex" justify="start" gutter={[10, 10]}>
            <Col xs={24} sm={24} md={24} lg={24} xl={24} className="text-center">
              <Button
                className="white-btn margin-r-2 width-3"
                href={constants.LINK_PAY_BALANCE}
              >
                Cancel
              </Button>
              <Button
                type="primary"
                htmlType="submit"
                className="green-btn margin-t-2 width-3"
              >
                Submit
              </Button>
            </Col>
          </Row>
        </Fragment>
      </Form>
    );
  }

  renderModalUI(modalType) {
    switch (modalType) {
      case 'YESBANK_OTP_SCREEN':
        return this.renderOtpScreen(YES_BANK_CARD_REPLACEMENT);
      default:
        return <div />;
    }
  }

  renderOtpScreen(type) {
    const {
      SelectUserDetails: {
        phone = '',
      } = {},
      isLoadingStatus = false,
    } = this.props;
    const {
      OTP,
      showResendText,
      remainingTime,
    } = this.state;
    return (
      <OtpScreen
        type={type}
        MobileNumber={phone}
        isLoadingStatus={isLoadingStatus}
        OTP={OTP}
        showResendText={showResendText}
        remainingTime={remainingTime}
        handleOTPChange={this.handleOTPChange}
        handleResendOtp={() => this.handleResendYblOtp(type)}
        verifyOTP={() => this.verifyYesBankOtp(type)}
      />
    );
  }

  render() {
    const {
      CardDataYbl = {},
      CardDataYbl: {
        renewal_data: {
          is_expired = false,
        } = {},

      } = {},
    } = this.props;
    const {
      modalType,
    } = this.state;
    return (
      <div>
        <Fragment>
          <Modal
            visible={!!modalType}
            onCancel={this.renderModalCloseFunction(modalType)}
            size="sm"
            classname="default-popup"
            footer={null}
            maskClosable={false}
          >
            {modalType && this.renderModalUI(modalType)}
          </Modal>
          <br clear="all" />
          <Container>
            <ZaggleCard>
              <Row align="middle" type="flex" gutter={24} className="margin-t-2">
                <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                  <h1>Manage Zaggle Cards</h1>
                  <Breadcrumb separator="<" className="margin-b-2 font-12 custom-breadcrumb">
                    <Item><Link to={constants.LINK_MY_PROFILE}>My Account</Link></Item>
                    <Item><Link to={constants.LINK_PAY_BALANCE}>Manage cards</Link></Item>
                    <Item>Renewal Card Details</Item>
                  </Breadcrumb>
                </Col>
              </Row>
              <Card className="rounded card-padding-20 noborder margin-b-1">
                <Row>
                  <Col xs={24} sm={24} md={12} lg={12} xl={12} className="margin-b-4">
                    {this.renderCardImages(CardDataYbl)}
                  </Col>
                  <Row>
                    { is_expired ? (
                      <Col xs={24} sm={24} md={12} lg={12} xl={12}>
                        {this.renderAddressForm()}
                      </Col>
                    ) : ''
                    }
                  </Row>
                </Row>
              </Card>
            </ZaggleCard>
          </Container>
        </Fragment>
      </div>
    );
  }
}

YesBankRenewalManagement.propTypes = YesBankRenewalManagementPropTypes;
const YesBankRenewalManagementWrapper = Form.create({ name: 'normal_admin' })(YesBankRenewalManagement);
export default connect(YesBankRenewalManagementStateToProps, YesBankRenewalManagementDispatchToProps)(AppWrappperHOC(YesBankRenewalManagementWrapper));
export { YesBankRenewalManagement };



// WEBPACK FOOTER //
// client/containers/YesBankRenewalManagement/index.js